import React from 'react';
import { FaInstagram, FaTwitter, FaLinkedin, FaGithub } from 'react-icons/fa';
import {  HiOutlineMail  } from 'react-icons/hi';

const Footer = () => {
  return (
    <div className='bg-[#3B6898] w-full h-[80px] flex justify-center items-center shadow-md shadow-[#040c16]'>
      <ul className='flex '>
        <li className='flex justify-center items-center'>
            <a href='https://www.linkedin.com/in/mariam-owolabi-11b969162' target='_blank' rel='noreferrer'><FaLinkedin size={20}/>
            </a>
        </li>
        <li>
            <a href='https://twitter.com/mariaam_oo?t=UTgqXL1H6RdBn0O426EjeQ&s=09' target='_blank' rel='noreferrer'><FaTwitter size={20}/>
            </a>
        </li>
        <li>
            <a className='' href='https://www.instagram.com/tolanii_i' target='_blank' rel='noreferrer'><FaInstagram size={20}/>
            </a>
        </li>
        <li>
            <a href='https://github.com/maariam000' target='_blank' rel='noreferrer'><FaGithub size={20}/>
            </a>
        </li>
        <li>
            <a href='mailto:owolabitolani8@gmail.com' target='_blank' rel='noreferrer' ><HiOutlineMail size={20}/>
            </a>
        </li>
      </ul>
      
    </div>
  )
}

export default Footer;
